export const unreachable = (value: any) => {
  console.warn(`Unreachable code: ${JSON.stringify(value)}`);
};
